import { c as _c } from "react/compiler-runtime";
import { useActiveFilterCount } from "../context";
import { RiFilter3Fill } from "react-icons/ri";
import Button from "@/components/ui/button";
import { DropdownMenuTrigger } from "@/components/ui/dropdown";
import { cx } from "@/lib/tailwind-utils";
interface TriggerProps {
  className?: string;
}
export function Trigger(t0) {
  const $ = _c(7);
  const {
    className
  } = t0;
  const count = useActiveFilterCount();
  let t1;
  if ($[0] !== className) {
    t1 = cx("rounded-full !py-1", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== count) {
    t2 = count > 0 ? <><div className="ml-2 h-3 w-px bg-primary" /><span className="mx-2 text-body text-primary">{count}</span></> : null;
    $[2] = count;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <DropdownMenuTrigger asChild={true}><Button variant="secondary" icon={RiFilter3Fill} className={t1}>Filters{t2}</Button></DropdownMenuTrigger>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}